import ProgressBar from "components/ProgressBar"
import {currency, translate} from 'filters'
import _ from "lodash"
import React from "react"
import Trans from '../../Trans'

type HighestBidMaxStatisticProps = {
  sumMaxBids: number
  bidLimit: number
  sumBids: number
}

type HighestBidMaxStatisticState = {
  step: number
}

export default class HighestBidMaxStatistic extends React.Component<HighestBidMaxStatisticProps, HighestBidMaxStatisticState> {
  constructor(props: HighestBidMaxStatisticProps) {
    super(props)
    this.state = {
      step: _.round(props.sumMaxBids / (props.bidLimit / 7))
    }
  };

  render() {
    return (
      <div className='statistic_box rounded'>
        <div className='statistic_box_body'>
          <h2>{translate("Summe Maximal")}</h2>
          <p>{translate("Summe aller Höchstbietenden Gebote inkl. Bietagenten")}</p>
          <div className='stat flex flex-col w-full w-full justify-center items-center'>
            <span>{currency(this.props.sumMaxBids)}</span>
            <ProgressBar step={'step-' + (this.state.step > 7 ? 7 : this.state.step)} valueNow={(this.props.sumBids / this.props.bidLimit) * 100}/>
          </div>
        </div>
      </div>
    )
  }
}
